import { createPinia, defineStore } from "pinia";

export default createPinia();

export const useMainStore = defineStore("main", {
  state: () => ({}),
  getters: {},
  actions: {},
});
